/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search-result-item[_ngcontent-%COMP%]{opacity:1}.search-result-item[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{height:1px;background:#f7f7f7}.search-result-item[_ngcontent-%COMP%]   .category-label[_ngcontent-%COMP%]{text-align:left;font-size:var(--ion-small-font-size);line-height:14px;letter-spacing:2.4px;opacity:1;text-transform:uppercase}.search-result-item[_ngcontent-%COMP%]   product-item-large[_ngcontent-%COMP%]     ion-item .product-name{font-family:\"Font Regular\"}"];
export { styles as styles };
